import { useEffect, useState } from "react";
import { useSyntecContext } from "api/settings/syntec/SyntecProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES, VAR_TYPES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";
import PropTypes from "prop-types";

export default function AdminSyntecPosCoef({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    syntecCoefById,
    syntecCoefByIdGetter,
    syntecCoefCreate,
    syntecCoefDeleteById,
    syntecCoefList,
    syntecCoefListGetter,
    syntecCoefUpdateById,
    syntecList,
    syntecListGetter,
  } = useSyntecContext();

  const [deleteData, setDeleteData] = useState(null);
  const [inputs, setInputs] = useState([]);

  useEffect(() => {
    syntecListGetter();
    syntecCoefListGetter();
  }, []);

  useEffect(() => {
    if (id) {
      syntecCoefByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (syntecPosCoefId) =>
    setDeleteData(syntecCoefList.find((e) => e.id === syntecPosCoefId));

  const validateDelete = async (syntecPosCoefId) => {
    try {
      await syntecCoefDeleteById(syntecPosCoefId);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCreate = (payload) => {
    try {
      syntecCoefCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  const handleEdit = (payload) => {
    try {
      syntecCoefUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  const syntecHandler = (syntecId) =>
    syntecList.find((e) => e.id === syntecId)?.name;

  const formatList = (list) =>
    list.flatMap((e) =>
      e.coef_position_syntec.map((elm) => ({
        ...elm,
        syntec: elm.syntec_id ? syntecHandler(elm.syntec_id) : "",
      }))
    );

  const formatSyntecPosCoef = (syntecPosCoef) =>
    syntecPosCoef?.syntec_id
      ? {
          ...syntecPosCoef,
          syntec_id: syntecHandler(syntecPosCoef.syntec_id),
        }
      : "";

  useEffect(() => {
    if (syntecCoefList.length > 0) {
      const choices = [{ name: "", value: null }].concat(
        syntecList.map((e) => ({
          name: e.name,
          value: e.id.toString(),
        }))
      );
      setInputs([
        { col: "value", mandatory: true, isMissingValue: null, editable: true },
        {
          col: "multiplier",
          mandatory: true,
          type: VAR_TYPES.NUMBER,
          step: "0.01",
          isMissingValue: null,
          editable: true,
        },
        {
          col: "function",
          mandatory: true,
          isMissingValue: null,
          editable: true,
        },
        {
          col: "syntec_id",
          mandatory: true,
          editable: true,
          isMissingValue: null,
          type: VAR_TYPES.DROPDOWN,
          choices,
        },
      ]);
    }
  }, [syntecCoefList, syntecList]);

  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.SYNTEC_POS_COEF}
        entityPerId={syntecCoefById}
        formattedEntity={formatSyntecPosCoef(syntecCoefById)}
        list={syntecCoefList?.length > 0 ? formatList(syntecCoefList) : []}
        inputs={inputs}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={formatSyntecPosCoef(deleteData)}
          entity={ENTITIES.SYNTEC_POS_COEF}
        />
      </div>
    </div>
  );
}

AdminSyntecPosCoef.propTypes = {
  action: PropTypes.string,
};
